import React from 'react';

// Extracted from StudentProfile.js as-is (Phase 3 of the platform-health
// plan: split the file mechanically, without changing behavior). All
// payment logic itself already lives in usePaymentBalance — this is purely
// the modal's markup, driven by props from the parent.
export default function PaymentModal({
  show,
  onClose,
  paymentBalance,
  paymentCurrency,
  lessonCountLabel,
  paidLessons,
  chargedLessons,
  payments,
  depositAmount,
  onDepositAmountChange,
  depositNote,
  onDepositNoteChange,
  onAddDeposit,
  chargeAmount,
  onChargeAmountChange,
  chargeNote,
  onChargeNoteChange,
  onAddCharge,
  defaultChargeAmount,
  onDeletePayment,
}) {
  if (!show) return null;

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal" onClick={e => e.stopPropagation()}>
        <div className="payment-modal-header">
          <div>
            <div className="payment-modal-title">Balance</div>
            <div className={`payment-modal-balance ${paymentBalance >= 0 ? 'positive' : 'negative'}`}>
              {paymentBalance >= 0 ? '+' : ''}{paymentCurrency}{Math.abs(paymentBalance).toFixed(2)}
              {paymentBalance < 0 && <span className="payment-modal-debt-label">Debt</span>}
            </div>
            {lessonCountLabel && (
              <div className={`payment-modal-lesson-count ${paymentBalance >= 0 ? 'positive' : 'negative'}`}>
                {lessonCountLabel}
              </div>
            )}
          </div>
          <button className="payment-modal-close" onClick={onClose}>✕</button>
        </div>

        {/* Stats row */}
        {(paidLessons !== null || chargedLessons !== null) && (
          <div className="payment-modal-stats">
            <div className="payment-modal-stat">
              <div className="payment-modal-stat-value positive">{chargedLessons ?? '—'}</div>
              <div className="payment-modal-stat-label">Lessons done</div>
            </div>
            <div className="payment-modal-stat-divider" />
            <div className="payment-modal-stat">
              <div className="payment-modal-stat-value">{paidLessons ?? '—'}</div>
              <div className="payment-modal-stat-label">Lessons paid</div>
            </div>
            <div className="payment-modal-stat-divider" />
            <div className="payment-modal-stat">
              <div className={`payment-modal-stat-value ${paymentBalance >= 0 ? 'positive' : 'negative'}`}>
                {paymentBalance < 0 ? (chargedLessons ?? 0) - (paidLessons ?? 0) : 0}
              </div>
              <div className="payment-modal-stat-label">Unpaid</div>
            </div>
          </div>
        )}

        {/* Add deposit */}
        <div className="payment-modal-section">
          <div className="payment-modal-section-title">Add payment</div>
          <div className="payment-modal-row">
            <input
              className="payment-modal-input"
              type="number"
              min="0"
              step="0.01"
              placeholder={`Amount (${paymentCurrency})`}
              value={depositAmount}
              onChange={e => onDepositAmountChange(e.target.value)}
            />
            <input
              className="payment-modal-input payment-modal-input-note"
              type="text"
              placeholder="Note (optional)"
              value={depositNote}
              onChange={e => onDepositNoteChange(e.target.value)}
            />
            <button className="payment-modal-add-btn deposit" onClick={onAddDeposit}>+ Deposit</button>
          </div>
        </div>

        {/* Add charge */}
        <div className="payment-modal-section">
          <div className="payment-modal-section-title">Add charge</div>
          <div className="payment-modal-row">
            <input
              className="payment-modal-input"
              type="number"
              min="0"
              step="0.01"
              placeholder={`Amount (${paymentCurrency})`}
              value={chargeAmount}
              onChange={e => onChargeAmountChange(e.target.value)}
              onFocus={() => { if (!chargeAmount && defaultChargeAmount) onChargeAmountChange(String(defaultChargeAmount)); }}
            />
            <input
              className="payment-modal-input payment-modal-input-note"
              type="text"
              placeholder="Note (optional)"
              value={chargeNote}
              onChange={e => onChargeNoteChange(e.target.value)}
            />
            <button className="payment-modal-add-btn charge" onClick={onAddCharge}>− Charge</button>
          </div>
        </div>

        {/* History */}
        <div className="payment-modal-section">
          <div className="payment-modal-section-title">History</div>
          {payments.length === 0 ? (
            <div className="payment-modal-empty">No transactions yet</div>
          ) : (
            <div className="payment-modal-history">
              {[...payments].reverse().map(p => (
                <div key={p.id} className={`payment-modal-row-item ${p.type}`}>
                  <div className="payment-modal-item-date">
                    {new Date(p.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
                  </div>
                  <div className="payment-modal-item-note">{p.note}</div>
                  <div className={`payment-modal-item-amount ${p.amount >= 0 ? 'positive' : 'negative'}`}>
                    {p.amount >= 0 ? '+' : ''}{paymentCurrency}{Math.abs(p.amount).toFixed(2)}
                  </div>
                  <button className="payment-modal-delete" onClick={() => onDeletePayment(p.id)} title="Delete">✕</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
